// extracted by mini-css-extract-plugin
export default {"Dropdown":"_1EIHJ","skeleton-progress":"FEOKm"};